import { DashboardMetricCard, DashboardMetricGrid } from '@yeshuman/sdk'
import { Pill, Leaf, CalendarHeart } from 'lucide-react'

import type { TherapeuticItem } from '../hooks/use-therapeutics'

interface TherapeuticStatsProps {
  therapeutics: TherapeuticItem[]
}

export function TherapeuticStats({ therapeutics }: TherapeuticStatsProps) {
  const meds = therapeutics.filter((t) => t.therapeutic_type === 'medication')
  const supps = therapeutics.filter((t) => t.therapeutic_type === 'supplement')
  const sessions = therapeutics.filter((t) => t.therapeutic_type === 'therapy_session')

  const latestMed = meds.sort(
    (a, b) => new Date(b.recorded_at).getTime() - new Date(a.recorded_at).getTime(),
  )[0]

  return (
    <DashboardMetricGrid maxColumns={4}>
      <DashboardMetricCard
        title="Entries"
        value={therapeutics.length}
        description="In current filter"
        icon={Pill}
      />
      <DashboardMetricCard
        title="Medications"
        value={meds.length}
        description={latestMed?.name ? `Latest: ${latestMed.name}` : 'None logged'}
        icon={Pill}
      />
      <DashboardMetricCard
        title="Supplements"
        value={supps.length}
        description="Logged entries"
        icon={Leaf}
      />
      <DashboardMetricCard
        title="Therapy sessions"
        value={sessions.length}
        description="Logged sessions"
        icon={CalendarHeart}
      />
    </DashboardMetricGrid>
  )
}
